import { useState } from 'react';
import { useLocation } from 'react-router';
import { Banner } from '../components/ui';

export interface Flash {
  text: string;
  /** A WhatsApp message staff can send with one tap (a link, so no popup is blocked). */
  wa?: { label: string; link: string };
}

/** Shows the message passed in `navigate(to, { state: { flash } })` once, at the top of the next screen. */
export function FlashBanner() {
  const loc = useLocation();
  const flash = (loc.state as { flash?: Flash } | null)?.flash;
  const [hidden, setHidden] = useState(false);
  if (!flash || hidden) return null;
  return (
    <Banner
      action={
        flash.wa ? (
          <a href={flash.wa.link} target="_blank" rel="noreferrer" onClick={() => setHidden(true)}>{flash.wa.label}</a>
        ) : (
          <button type="button" className="link" onClick={() => setHidden(true)}>OK</button>
        )
      }
    >
      {flash.text}
    </Banner>
  );
}
